import styled from 'styled-components';

export const HeaderStyles = styled.div`
  position: relative;
  width: calc(100% - 4px);
  text-align: left;
  padding: 2px;

  .headline {
    font-family: 'Ubuntu', sans-serif;
    font-size: 24px;
    font-weight: 700;
    border-left: 4px solid #cf1a17;
    padding-left: 16px;
    margin-bottom: 20px;
    line-height: 31px;
  }
`;
